import { ProjectUpgradeOptionsApi } from 'api-typings/projects/projects';

export type ProjectUpdateActionRawPayload =
  | {
      readonly action: Exclude<ProjectAction, ProjectAction.UPGRADE>;
    }
  | {
      readonly action: ProjectAction.UPGRADE;
      readonly 'upgrades[]': ReadonlyArray<ProjectUpgradeOptionsApi>;
    };

export enum ProjectAction {
  SIGN_NDA = 'sign_nda',
  UPGRADE = 'upgrade',
  SET_LOCATION = 'set_location',
  CLOSE = 'close',
  ADD_ATTACHMENT = 'add_attachment',
  END = 'end',
}
